// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const List: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve" fill="currentColor">
<rect x="6.12" y="4.35" width="17.73" height="1.4"/>
<path d="M4.43,6.71H0.15V3.39h4.28V6.71z M1.55,5.31h1.48V4.79H1.55V5.31z"/>
<rect x="6.12" y="11.42" width="17.73" height="1.4"/>
<path d="M4.43,13.78H0.15v-3.32h4.28V13.78z M1.55,12.38h1.48v-0.52H1.55V12.38z"/>
<rect x="6.12" y="18.25" width="17.73" height="1.4"/>
<path d="M4.43,20.61H0.15v-3.32h4.28V20.61z M1.55,19.21h1.48v-0.52H1.55V19.21z"/>
</svg>;
};

export default React.memo(List);
